import { render, staticRenderFns } from "./MatchingSentences.vue?vue&type=template&id=0e41ad06&scoped=true&"
import script from "./MatchingSentences.vue?vue&type=script&lang=js&"
export * from "./MatchingSentences.vue?vue&type=script&lang=js&"
import style0 from "./MatchingSentences.vue?vue&type=style&index=0&id=0e41ad06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e41ad06",
  null
  
)

export default component.exports